import React, { useState } from 'react'
import NewActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import styles from './RowPrice.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const RowPrice = ({ price, index, action }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: 'Edit', action: 'edit' },
    { name: 'Delete', action: 'delete' },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {price.name}, {price.price_sum} тг. {price.hours_sum}{' '}
            {price.hours_type.short_name}/ч
          </div>
          <div className={styles.buttons}>
            <NewActionMenu variant='simple' onSimpleAction={toggleExpand} />
            <ActionMenu menu={menu} action={action} items={price} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Компания:</div>
            <div className={styles.info}>{price.company.name}</div>
          </div>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Сумма:</div>
            <div className={styles.info}>{price.price_sum}</div>
          </div>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Количество часов:</div>
            <div className={styles.info}>{price.hours_sum}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default RowPrice
